import GoogleButton from './GoogleButton'

export default GoogleButton
